//SLIDER FROM MAIN
export const backgroundImages: string[] = [
  "https://filmicmag.files.wordpress.com/2016/06/truman-show3.jpg",
  "https://film-grab.com/wp-content/uploads/2020/10/Tokyo-Gore-Police-013.jpg",
  "https://i.ytimg.com/vi/aau8qa3xgFs/maxresdefault.jpg",
  "https://static.boredpanda.com/blog/wp-content/uploads/2015/08/epic-movie-scenes-screenshots-28__880.jpg",
];
//Learning assets

export const extremeLongShot = [
  { source: "https://www.techdigest.tv/hogwarts.jpg" },

  {
    source:
      "https://stillsfrmfilms.files.wordpress.com/2013/05/39.jpg?w=1400&h",
  },
  {
    source:
      "http://u100s.s3.amazonaws.com/articles_images/w0/145498083340/image.jpg",
  },
];

export const fullShot = [
  {
    source:
      "https://cdn.careersinfilm.com/wp-content/uploads/2019/05/full-shot-thor.jpeg",
  },

  {
    source:
      "https://s.studiobinder.com/wp-content/uploads/2019/09/Camera-Shot-Guide-Full-Shot-2-Django-Unchained-StudioBinder.jpg.webp",
  },
  {
    source:
      "http://a-staff.weebly.com/uploads/2/2/8/0/22807460/jack-sparrow_orig.jpeg",
  },
  {
    source:
      "https://pelikulangromansa.files.wordpress.com/2013/10/breakfast-at-tiffany-s-audrey-hepburn-2297288-1024-576.jpg?w=300&h=168",
  },
];
